import { render, staticRenderFns } from "./EditOrganization.vue?vue&type=template&id=6a876aeb&"
import script from "./EditOrganization.vue?vue&type=script&lang=ts&"
export * from "./EditOrganization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports